import { MapFeature } from './map-feature'
import { getProjectionComponent } from './projection'
import { useStyles } from './map-layer.style'

export const MapLayer = ({ topology, projectionType, projectionProps, zoom, handleZoomClick, isZoomedIn }) => {
  const classes = useStyles()
  const Projection = getProjectionComponent(projectionType)

  if (!topology) {
    return null
  }

  return <>
    <Projection data={topology.features} {...projectionProps}>
      {(projection) => (
        <g>
          {projection.features.map(({ feature }, index) => (
            <MapFeature
              key={`feature-layer-${index}`}
              pathDefinition={projection.path(feature)}
              color="transparent"
              enableMouseEvents={!isZoomedIn}
              className={classes.layer}
              onClick={(event) => { handleZoomClick(event, zoom) }}
            />
          ))}
        </g>
      )}
    </Projection>
  </>
}

export const areMapLayersEqual = (prev, next) => {
  return (prev.projectionType === next.projectionType) && (prev.isZoomedIn === next.isZoomedIn) && (prev.width === next.width) && (prev.height === next.height)
}
